import React from "react";
import styles from "../modules/HomePage.module.css";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";

const HomePage = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    window.scrollTo(0, 0);
    navigate("/services");
  };

  return (
    <div className={styles.homeContainer}>
      {/* HEADER SECTION */}
      <section className={styles.hero}>
        {/* NAVBAR */}
        <div className={styles.navbar}>
          <div className={styles.navbarContainer}>
            {/* Logo */}
            <div className={styles.navbarLogo}>
              <img src="/logo.png" alt="Shonix Solutions" className={styles.logo} />
            </div>

            {/* Navigation Links */}
            <div className={styles.navLinks}>
              <ScrollLink to="about" smooth={true} duration={800} offset={-70}> About Us </ScrollLink>
              <ScrollLink to="services" smooth={true} duration={800} offset={-70}> Services </ScrollLink>
              <ScrollLink to="footer" smooth={true} duration={800} offset={-70}> Contact Us </ScrollLink>
            </div>
          </div>
        </div>

        {/* HERO CONTENT */}
        <div className={styles.heroContent}>
          <h1>We Build Solutions.</h1>
          <p>
            At <strong>Shonix Solutions</strong>, we craft software that adapts to you — not the
            other way around. Our team designs tailored software, data tools, and websites
            based on how your business truly operates.
          </p>
          <button
            className={`${styles.btn} ${styles.primary}`}
            onClick={() => window.location.href = "https://wa.me/918019666702?text=Hi%20Shonix%20Solutions!%20I%20would%20like%20to%20know%20more%20about%20your%20services."}
          >
            Get Your Free Consultation
          </button>
        </div>

        <div className={styles.heroImage}>
          <img src="/Dashboard.png" alt="Dashboard" />
        </div>
      </section>

      {/* WHO WE ARE */}
      <section id="about" className={styles.about}>
        <div className={styles.aboutContent}>
          <h1>WHO WE ARE</h1>
          <h2>
            We Don’t Sell Templates.
            <br />
            We Build Solutions.
          </h2>
          <p>
            We believe software should adapt to your business — not the other way around. Our goal
            is to provide efficient and affordable solutions that meet your needs.
          </p>
          <Link to="/aboutus" onClick={() => window.scrollTo(0, 0)} > Know more </Link>
          <div className={styles.aboutCard}>
            <div className={styles.card}>
              <img src="/logo-5.png" alt="About Cards" className={styles.logo} />
              <h3>Customized Software</h3>
            </div>
            <div className={styles.card}>
              <img src="/logo-6.png" alt="About Cards" className={styles.logo} />
              <h3>Data-Driven Insights</h3>
            </div>
          </div>
        </div>

        <div className={styles.aboutFeatures}>
          <div className={styles.feature}>
            <img src="/logo-1.png" alt="Feature cards" className={styles.logo} />
            <h3>Offline Software</h3>
            <p>
              POS and management systems for restaurants, hospitals, and retailers — fully
              functional without internet dependency.
            </p>
          </div>
          <div className={styles.feature}>
            <img src="/logo-2.png" alt="Feature cards" className={styles.logo} />
            <h3>Custom Software Development</h3>
            <p>Tailored applications and tools that match your process and workflow.</p>
          </div>
          <div className={styles.feature}>
            <img src="/logo-3.png" alt="Feature cards" className={styles.logo} />
            <h3>Data Analysis & Reports</h3>
            <p>
              Extracting actionable insights from your data to help you make informed decisions.
            </p>
          </div>
          <div className={styles.feature}>
            <img src="/logo-4.png" alt="Feature cards" className={styles.logo} />
            <h3>Website Development</h3>
            <p>Modern, responsive, and SEO-friendly websites crafted to your brand’s needs.</p>
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section id="services" className={styles.industries}>
        <h1>Tailored for Every Industry</h1>
        <h3>Each business is unique — your software should be too.</h3>

        <div className={styles.industryList}>
          <div className={styles.industryCard}>
            <img src="/logo-9.png" alt="Industry Cards" className={styles.logo} />
            <h3>Education</h3>
            <button className={styles.industryBtn} style = {{ marginTop:"9%", }} onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className={styles.industryCard}>
            <img src="/logo-8.png" alt="Industry Cards" className={styles.logo} />
            <h3>Hospitals & Clinics</h3>
            <button className={styles.industryBtn} style = {{ marginTop:"9%", }} onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className={styles.industryCard}>
            <img src="/logo-7.png" alt="Industry Cards" className={styles.logo} />
            <h3>Cafes & Restaurants</h3>
            <button className={styles.industryBtn} style = {{ marginTop:"9%", }} onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className={styles.industryCard}>
            <img src="/logo-11.png" alt="Industry Cards" className={styles.logo} />
            <h3>Retail & Inventory</h3>
            <button className={styles.industryBtn} style = {{ marginTop:"9%", }} onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className={styles.industryCard}>
            <img src="/logo-12.png" alt="Industry Cards" className={styles.logo} />
            <h3>Small Businesses</h3>
            <button className={styles.industryBtn} style = {{ marginTop:"9%", }} onClick={handleLearnMore}>Learn More</button>
          </div>
          <div className={styles.industryCard}>
            <img src="/logo-10.png" alt="Industry Cards" className={styles.logo} />
            <h3>Video Editing / Trailer Making</h3>
            <button className={styles.industryBtn} onClick={handleLearnMore}>Learn More</button>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className={styles.whyChoose}>
        <div className={styles.whyContent}>
          <h1>
            Why Businesses <br /> Choose Shonix Solutions
          </h1>
          <ul>
            <li>➤ Fully Custom — designed per user needs</li>
            <li>➤ Direct Developer Communication</li>
            <li>➤ Fast Delivery, Local Support</li>
          </ul>
        </div>
        <div className={styles.whyImage}>
          <img src="Analytics.png" alt="Shonix Dashboard" />
        </div>
      </section>

      {/* FOOTER */}
      <footer id="footer" className={styles.footer}>
        <div className={styles.footerContent}>
          <img
            src="/logo-13.png"
            alt="Shonix Solutions"
            className={styles.logo}
          />
          <h1>
            Empowering Businesses
            <br /> with Digital Efficiency.
          </h1>
        </div>

        <div className={styles.footerContact}>
          <h1>Stay Connected</h1>
          <ul>
            <li>
              <i style = {{ marginRight: "8px", color: "rgb(134 137 148)" }} className="fa fa-envelope" ></i>
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=shonixsolutions@gmail.com&su=Inquiry%20from%20Shonix%20Website&body=Hi%20Shonix%20Solutions%2C%0D%0A%0D%0AI'd%20like%20to%20know%20more%20about%20your%20services."
                 style={{ textDecoration: "none", color: "#ffffffff" }}>
                shonixsolutions@gmail.com
              </a>
            </li>
            <li>
              <i style={{ marginRight: "8px", color: "rgb(134 137 148)" }} className="fa fa-linkedin" ></i>
              <a href="https://www.linkedin.com/in/shonix-solutions-b4aa25398"
                 style={{ textDecoration: "none", color: "#ffffffff" }}>
                shonix-solutions
              </a>
            </li>
            <li>
              <i style={{ marginRight: "8px", color: "rgb(134 137 148)" }} className="fa fa-instagram" ></i>
              <a href="https://www.instagram.com/shonix_solutions?igsh=emNzeXF0MW4yMWl4&utm_source=qr" 
                 style={{ textDecoration: "none", color: "#ffffffff" }}>
                shonix_solutions
              </a>
            </li>
            <li>
              <i style={{ marginRight: "8px", color: "rgb(134 137 148)" }} className="fa fa-whatsapp" ></i>
              <a href="https://wa.me/918019666702?text=Hi%20Shonix%20Solutions!%20I%20would%20like%20to%20know%20more%20about%20your%20services." 
                 style={{ textDecoration: "none", color: "#ffffffff" }}>
                Shonix Solutions
              </a>
            </li>
            <li>
              <i
                style={{ marginRight: "8px", color: "rgb(134 137 148)" }}
                className="fa fa-phone"
              ></i>
              +91 8019666702
            </li>
          </ul>
        </div>

        <div className={styles.footerCopyright}>
          <hr
            style={{
              width: "95%",
              margin: "0 auto 1rem auto",
              border: "1px solid rgb(52 62 93)",
            }}
          />
          <p>© 2025 Shonix Solutions. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
